import nipplejs from 'nipplejs';

export default class Joystick {
    constructor(objCharacter, characterSelected, speedToCharacter, hasLightstick = false, onlyUpDown = false) {

        this.characterSelected = characterSelected;
        this.objCharacter = objCharacter;
        this.speedToCharacter = speedToCharacter;
        this.hasLightstick = hasLightstick;
        this.onlyUpDown = onlyUpDown;

        this.joystickManager = null;

        this.isToLeft = false;


        this.objCreate = {
            mode: 'static',
            position: { left: '50%', top: '50%' },
            zone: document.getElementById('joystick-area'),
            dynamicPage: true,
            size: 80
        };

        if (this.onlyUpDown) {
            this.objCreate['lockY'] = true;
        }

    }

    createJoystick() {
        if (this.objCharacter) {
            this.joystickManager = nipplejs.create(this.objCreate);

        }
    }

    activate(hasLightstick = false, keepReposeAninateRight = false) {
        this.hasLightstick = hasLightstick
        this.keepReposeAninateRight = keepReposeAninateRight;
        // if (!this.alreadyActive ) {
        //     this.alreadyActive = true;
            

            if(this.keepReposeAninateRight) {
                this.objCharacter.anims.play(`right-${this.characterSelected}`, true);
            }

            this.joystickManager.on('move', (data, output) => {

                if(this.joystickBlocked) return;

                // get the force and don't let it be greater than 1
                let force = Math.min(output.force, 1);

                // get the angle, in radians
                let angle = output.angle.radian;

                // determine the speed, according to force and player speed
                let speed = this.speedToCharacter * force;

                if(this.onlyUpDown) {
                    this.objCharacter.anims.play(`right-${this.characterSelected}`, true);
                    this.isToLeft = false;

                } else {
                    if (angle >= 1 && angle < 2) {
                        this.objCharacter.anims.play(`up-${this.characterSelected}`, true);
                        this.isToLeft = false;
    
                    }
    
                    if (angle >= 2 && angle < 4) {
                        this.objCharacter.anims.play(`left-${this.characterSelected}`, true);
                        this.isToLeft = true;
                    }
    
                    if (angle >= 4 && angle < 5) {
                        this.objCharacter.anims.play(`down-${this.characterSelected}`, true);
                        this.isToLeft = false;
    
                    }
    
                    if (angle < 1 || angle >= 5) {
                        this.objCharacter.anims.play(`right-${this.characterSelected}`, true);
                        this.isToLeft = false;
    
                    }

                }



                this.objCharacter.setVelocity(speed * Math.cos(angle), speed * Math.sin(angle) * -1);




                // set player velocity using trigonometry

            });

            this.joystickManager.on('end', () => {

                if(this.joystickBlocked) return;

                this.isToLeft = false;

                // stop the player
                if (this.hasLightstick) {
                    this.objCharacter.anims.play(`lightstick-${this.characterSelected}`, true);

                } else {
                    if(this.keepReposeAninateRight) {
                        this.objCharacter.anims.play(`right-${this.characterSelected}`, true);
                    } else {
                        this.objCharacter.anims.play(`repose-${this.characterSelected}`, true);
                    }
                }

                this.objCharacter.setVelocity(0, 0);
            });

        // } 

    }

    setLightStickValue(value) {
        this.hasLightstick = value;
    }

    destroyTest() {
        if(this.joystickManager) {
            this.joystickManager.destroy();
            // this.joystickManager = null;
            // this.objCharacter.setVelocity(0, 0);
            // this.objCharacter.anims.play(`repose-${this.characterSelected}`, true);
            // this.alreadyActive = false;
        }
    }

    show() {
        if(this.joystickManager) {
            this.joystickBlocked = false;
            const nippleElements = document.querySelectorAll('.nipple');
            nippleElements.forEach((el) => {
                el.style.display = 'block'; // Mostrar visualmente
            });

            // this.objCharacter.setVelocity(0, 0);
            // this.objCharacter.anims.play(`repose-${this.characterSelected}`, true);
        }
    }

    pause() {
        if(this.joystickManager) {
            this.joystickBlocked = true
            const nippleElements = document.querySelectorAll('.nipple');
            nippleElements.forEach((el) => {
                el.style.display = 'none'; // Ocultar visualmente
            });

        }
    }
}